import React, { ReactElement, useContext } from 'react'
import { DashboardDisplaySettings as DashboardDisplaySettingsLanguage } from '../../../../i18n'
import LanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import Fieldset from '../../Common/Components/Fieldset'
import Heading from '../../Common/Components/Heading'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'
import P from '../../Common/Components/P'
import { LanguageContext } from '../../Common/Contexts'
import LayoutOption from './LayoutOptions/LayoutOption'
import { DashboardLayoutStyle } from './Types'

// CSS imports. Commented out because of current build process.
// import './displaySettings.scss'

export type DisplaySettingsProps = {
    selectedDashboardLayoutStyle: DashboardLayoutStyle
    setSelectedDashboardLayoutStyle: (value: DashboardLayoutStyle) => void
}

/**
 * Component displaying layout settings for dashboard report.
 *
 * @param selectedDashboardLayoutStyle Currently selected layout style for dashboard report.
 * @param setSelectedDashboardLayoutStyle Setter for respective property.
 */
const DisplaySettings: React.FC<DisplaySettingsProps> = ({
    selectedDashboardLayoutStyle,
    setSelectedDashboardLayoutStyle
}): ReactElement => {
    const language = useContext(LanguageContext) as LanguageHandler
    language.loadBundle('DashboardDisplaySettings')

    const availableLayoutStyles: number[] = [
        DashboardLayoutStyle.Layout1x1,
        DashboardLayoutStyle.VerticalSplit,
        DashboardLayoutStyle.HorizontalSplit,
        DashboardLayoutStyle.Layout1Left2Right,
        DashboardLayoutStyle.Layout1Top2Bottom,
        DashboardLayoutStyle.Layout3x1,
        DashboardLayoutStyle.Layout2x2,
        DashboardLayoutStyle.Layout1Top3Bottom,
        DashboardLayoutStyle.Layout1Left2Middle2Right,
        DashboardLayoutStyle.Layout2Top3Bottom,
        DashboardLayoutStyle.Layout3x2
    ]

    return (
        <Fieldset className='display-settings'>
            <div className='notations'>
                <Heading level={HeadingLevel.TWO}>
                    {language?.get(DashboardDisplaySettingsLanguage.DashboardDisplaySettings_SectionHeader)}
                </Heading>
                <P>{language.get(DashboardDisplaySettingsLanguage.Para1)}</P>
            </div>
            <div className={'layout-options'}>
                {availableLayoutStyles.map((availableLayoutStyle: DashboardLayoutStyle) => (
                    <LayoutOption
                        key={availableLayoutStyle}
                        layoutType={availableLayoutStyle}
                        isSelected={selectedDashboardLayoutStyle === availableLayoutStyle}
                        handleChange={(): void => setSelectedDashboardLayoutStyle(availableLayoutStyle)}
                    />
                ))}
            </div>
        </Fieldset>
    )
}

export default DisplaySettings
